import Dashboard from "./pages/dashboard";
import Account from "./pages/account/account";
import Billing from "./pages/billing/billing";
import Domains from "./pages/domains/domains";
import DomainGroup from "./pages/domains/domain_group";
import Firewall from "./pages/firewall/firewall";
import IPAddresses from "./pages/ip_addresses/ip_addresses";
import IPAddressGroup from "./pages/ip_addresses/ip_address_group";
import CompanySelector from "./components/account/CompanySelector";
import InvoiceView from "./components/billing/InvoiceView";
import OrderView from "./components/billing/OrderView";
import CreditNoteView from "./components/billing/CreditNoteView";
import HostingAccounts from "./pages/hosting/hosting_accounts";
import ManageCompany from "./pages/account/manage_company";
import HostingDetails from "./pages/hosting/hosting_details";
import FirewallRuleDetail from "./pages/firewall/firewall_rule_detail";
import {RiDashboardLine} from "react-icons/ri";
import {BsGlobe, BsShieldFill} from "react-icons/bs";
import {HiLocationMarker, HiShoppingCart} from "react-icons/hi";
import {FaBook, FaServer} from "react-icons/fa";
import {BiUser} from "react-icons/bi";
import {IoBusinessOutline, IoDocumentTextOutline, IoGitNetworkOutline} from "react-icons/io5";
import React from "react";
import {MdSupport} from "react-icons/md";
import Affiliate from "./pages/affiliate/affiliate";
import AffiliateSignup from "./components/affiliate/AffiliateSignup";
import AffiliateInvoice from "./pages/affiliate/affiliate_invoice";
import {ShoppingOutlined} from "@ant-design/icons";
import Services from "./pages/services/services";
import WaybackMachineRestorationProjects from "./pages/wayback_machine_restoration/wayback_machine_restoration";
import {CgWebsite} from "react-icons/cg";
import WaybackMachineRestorationProject from "./pages/wayback_machine_restoration/wayback_machine_restoration_project";
import ArticleEditor from "./pages/content/article_editor";
import ContentProject from "./pages/content/content_project";
import ContentProjects from "./pages/content/content_projects";
import Support from "./pages/support/support";

export const sidebarMenu = {
    '/': {
        name: 'Dashboard',
        page: Dashboard,
        exact: true,
        icon: <RiDashboardLine style={{marginBottom: '-2px'}} />,
        scopes: [],
        mode: ['SIMPLE', 'ADVANCED'],
        min_domain_count: 0
    },
    '/domains': {
        name: 'Domains',
        page: Domains,
        exact: true,
        icon: <BsGlobe style={{marginBottom: '-2px'}} />,
        scopes: ['can_view_domains'],
        mode: ['SIMPLE', 'ADVANCED'],
        min_domain_count: 0
    },
    '/domains/:group/:tab': {
        page: DomainGroup,
        exact: false,
        subpage: true,
        name: 'Domain Group',
        scopes: ['can_view_domains'],
        mode: ['SIMPLE', 'ADVANCED'],
        min_domain_count: 0
    },
    '/domains/:group': {
        page: DomainGroup,
        exact: false,
        subpage: true,
        name: 'Domain Group',
        scopes: ['can_view_domains'],
        mode: ['SIMPLE', 'ADVANCED'],
        min_domain_count: 0
    },
    '/ip-addresses': {
        name: 'IP Addresses',
        page: IPAddresses,
        exact: true,
        subpage: false,
        icon: <HiLocationMarker style={{marginBottom: '-2px'}} />,
        scopes: ['can_view_ip_addresses'],
        mode: ['ADVANCED'],
        min_domain_count: 0
    },
    '/ip-addresses/:group': {
        page: IPAddressGroup,
        exact: false,
        subpage: true,
        name: 'IP Address Group',
        scopes: ['can_view_ip_addresses'],
        mode: ['ADVANCED'],
        min_domain_count: 0
    },
    '/hosting': {
        name: 'Hosting Accounts',
        page: HostingAccounts,
        exact: true,
        subpage: false,
        icon: <FaServer style={{marginBottom: '-2px'}} />,
        scopes: ['can_view_hosting'],
        mode: ['ADVANCED'],
        min_domain_count: 0
    },
    '/hosting/:guid': {
        page: HostingDetails,
        exact: false,
        subpage: true,
        scopes: ['can_view_hosting'],
        mode: ['ADVANCED'],
        min_domain_count: 0
    },
    '/firewall': {
        name: 'Firewall',
        page: Firewall,
        exact: true,
        subpage: false,
        icon: <BsShieldFill style={{marginBottom: '-2px'}} />,
        scopes: ['can_view_firewall'],
        mode: ['ADVANCED'],
        min_domain_count: 0
    },
    '/firewall/add': {
        name: 'Firewall' ,
        page: FirewallRuleDetail,
        exact: true,
        subpage: true,
        scopes: ['can_view_firewall'],
        mode: ['ADVANCED'],
        min_domain_count: 0
    },
    '/firewall/edit/:guid': {
        name: 'Firewall' ,
        page: FirewallRuleDetail,
        exact: true,
        subpage: true,
        scopes: ['can_view_firewall'],
        mode: ['ADVANCED'],
        min_domain_count: 0
    },
    '/firewall/:page': {
        page: Firewall,
        exact: true,
        subpage: true,
        scopes: ['can_view_firewall'],
        mode: ['ADVANCED'],
        min_domain_count: 0
    },
    '/website-restoration': {
        page: WaybackMachineRestorationProjects,
        exact: true,
        subpage: false,
        name: 'Website Restoration',
        icon: <CgWebsite style={{marginBottom: '-2px'}} />,
        scopes: ['can_view_wayback_machine_restoration'],
        mode: ['SIMPLE', 'ADVANCED'],
        min_domain_count: 1
    },
    '/website-restoration/:guid': {
        page: WaybackMachineRestorationProject,
        exact: false,
        subpage: true,
        scopes: ['can_view_wayback_machine_restoration'],
        mode: ['SIMPLE', 'ADVANCED'],
        min_domain_count: 1
    },
    '/content/:guid/articles/:article_guid': {
        page: ArticleEditor,
        exact: false,
        subpage: true,
        scopes: ['can_use_content_writer'],
        mode: ['SIMPLE', 'ADVANCED'],
        min_domain_count: 1
    },
    '/content/:guid/articles': {
        page: ArticleEditor,
        exact: true,
        subpage: true,
        scopes: ['can_use_content_writer'],
        mode: ['SIMPLE', 'ADVANCED'],
        min_domain_count: 1
    },
    '/content/:guid': {
        page: ContentProject,
        exact: false,
        subpage: true,
        scopes: ['can_view_content_writer'],
        mode: ['SIMPLE', 'ADVANCED'],
        min_domain_count: 1
    },
    '/content': {
        page: ContentProjects,
        exact: true,
        subpage: false,
        name: 'Content Writer',
        icon: <IoDocumentTextOutline style={{marginBottom: '-2px'}} />,
        scopes: ['can_view_content_writer'],
        mode: ['SIMPLE', 'ADVANCED'],
        min_domain_count: 1
    },
    '/billing': {
        name: 'Billing' ,
        page: Billing,
        exact: true,
        subpage: false,
        icon: <HiShoppingCart style={{marginBottom: '-2px'}} />,
        scopes: ['can_view_billing'],
        mode: ['SIMPLE', 'ADVANCED'],
        min_domain_count: 0
    },
    '/billing/orders/:id': {
        name: 'Billing' ,
        page: OrderView,
        exact: false,
        subpage: true,
        scopes: ['can_view_billing', 'can_view_orders'],
        mode: ['SIMPLE', 'ADVANCED'],
        min_domain_count: 0
    },
    '/billing/invoices/:id': {
        name: 'Billing' ,
        page: InvoiceView,
        exact: false,
        subpage: true,
        scopes: ['can_view_billing', 'can_view_invoices'],
        mode: ['SIMPLE', 'ADVANCED'],
        min_domain_count: 0
    },
    '/billing/credit_notes/:id': {
        name: 'Billing' ,
        page: CreditNoteView,
        exact: false,
        subpage: true,
        scopes: ['can_view_billing'],
        mode: ['SIMPLE', 'ADVANCED'],
        min_domain_count: 0
    },
    '/billing/:page': {
        name: 'Billing' ,
        page: Billing,
        exact: false,
        subpage: true,
        scopes: ['can_view_billing'],
        mode: ['SIMPLE', 'ADVANCED'],
        min_domain_count: 0
    },
    '/services': {
        name: 'Add-on Services' ,
        page: Services,
        exact: true,
        subpage: false,
        icon: <ShoppingOutlined />,
        scopes: ['can_view_billing'],
        mode: ['ADVANCED'],
        min_domain_count: 0
    },
    '/account/select-company/:guid': {
        page: CompanySelector,
        exact: false,
        subpage: true,
        scopes: ['can_switch_companies'],
        allow_customer: false,
        mode: ['SIMPLE', 'ADVANCED'],
        min_domain_count: 0
    },
    '/account/company/:guid/:page': {
        page: ManageCompany,
        exact: false,
        subpage: true,
        scopes: ['can_view_company_info'],
        allow_customer: false,
        mode: ['SIMPLE', 'ADVANCED'],
        min_domain_count: 0
    },
    '/account/company/:guid': {
        page: ManageCompany,
        exact: false,
        subpage: true,
        scopes: ['can_view_company_info'],
        allow_customer: false,
        mode: ['SIMPLE', 'ADVANCED'],
        min_domain_count: 0
    },
    '/account/:page/:key': {
        name: 'Account',
        page: Account,
        exact: false,
        subpage: true,
        show_user: true,
        scopes: [],
        allow_customer: false,
        mode: ['SIMPLE', 'ADVANCED'],
        min_domain_count: 0
    },
    '/account': {
        name: 'Account',
        page: Account,
        exact: true,
        subpage: true,
        show_user: true,
        scopes: [],
        icon: <BiUser style={{marginBottom: '-2px'}} />,
        allow_customer: false,
        mode: ['SIMPLE', 'ADVANCED'],
        min_domain_count: 0
    },
    '/account/:page': {
        name: 'Account',
        page: Account,
        exact: false,
        subpage: true,
        show_user: true,
        scopes: [],
        allow_customer: false,
        mode: ['SIMPLE', 'ADVANCED'],
        min_domain_count: 0
    },
    '/company': {
        name: 'Company',
        page: ManageCompany,
        exact: true,
        subpage: true,
        scopes: ['can_view_company_info'],
        icon: <IoBusinessOutline style={{marginBottom: '-2px'}} />,
        allow_customer: false,
        mode: ['SIMPLE', 'ADVANCED'],
        min_domain_count: 0
    },
    '/company/:guid/:page': {
        name: 'Company',
        page: ManageCompany,
        exact: false,
        subpage: true,
        scopes: ['can_view_company_info'],
        allow_customer: false,
        mode: ['SIMPLE', 'ADVANCED'],
        min_domain_count: 0
    },
    '/company/:page': {
        name: 'Company',
        page: ManageCompany,
        exact: false,
        subpage: true,
        scopes: ['can_view_company_info'],
        allow_customer: false,
        mode: ['SIMPLE', 'ADVANCED'],
        min_domain_count: 0
    },
    '/company/:guid': {
        name: 'Company',
        page: ManageCompany,
        exact: false,
        subpage: true,
        scopes: ['can_view_company_info'],
        allow_customer: false,
        mode: ['SIMPLE', 'ADVANCED'],
        min_domain_count: 0
    },
    '/affiliate': {
        name: 'Affiliate',
        page: Affiliate,
        exact: true,
        subpage: false,
        scopes: [],
        icon: <IoGitNetworkOutline style={{marginBottom: '-2px'}} />,
        allow_customer: false,
        mode: ['SIMPLE', 'ADVANCED'],
        min_domain_count: 0
    },
    '/affiliate/create': {
        name: 'Affiliate',
        page: AffiliateSignup,
        exact: false,
        subpage: true,
        scopes: [],
        allow_customer: false,
        mode: ['SIMPLE', 'ADVANCED'],
        min_domain_count: 0
    },
    '/affiliate/billing/invoice/:id': {
        page: AffiliateInvoice,
        exact: false,
        subpage: true,
        scopes: [],
        allow_customer: false,
        mode: ['SIMPLE', 'ADVANCED'],
        min_domain_count: 0
    },
    '/affiliate/:page': {
        name: 'Affiliate',
        page: Affiliate,
        exact: false,
        subpage: true,
        scopes: [],
        allow_customer: false,
        mode: ['SIMPLE', 'ADVANCED'],
        min_domain_count: 0
    },
    '/support': {
        name: 'Support',
        page: Support,
        external: false,
        subpage: false,
        scopes: [],
        icon: <MdSupport style={{marginBottom: '-2px'}} />,
        allow_customer: false,
        mode: ['SIMPLE', 'ADVANCED'],
        min_domain_count: 0
    },
    'https://support.priorityprospect.com/knowledgebase': {
        name: 'Knowledge Base',
        page: null,
        external: true,
        subpage: false,
        scopes: [],
        icon: <FaBook style={{marginBottom: '-2px'}} />,
        allow_customer: false,
        mode: ['SIMPLE', 'ADVANCED'],
        min_domain_count: 0
    }
};